import type { IconProps } from '.';

/**
 * Chevron Left Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ChevronLeftIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.70707 12L14.3535 6.35353L13.6464 5.64642L7.29286 12L13.6464 18.3535L14.3535 17.6464L8.70707 12Z"
      fill="white"
    />
  </svg>
);

export default ChevronLeftIcon;
